'use strict';

angular.module('amexReconciliationApp')
  .service('TpdRepository', function ($http) {
    this.findByTransactionIdAndBillingCycle = function (billingCycle, transaction, showUnlinkedOnly) {
      var tpdParams = {
        transactionId: transaction.id,
        endDate: convertToISOString(billingCycle.endDate),
        startDate: convertToISOString(billingCycle.startDate),
        filter: showUnlinkedOnly ? 'ONLY_UNLINKED' : 'ALL'
      };

      return $http({
        method: 'GET',
        url: '/api/v1/tpd-by-transaction-and-billing-cycle',
        params: tpdParams
      }).then(function (response) {
        return response.data;
      });
    };

    var convertToISOString = function(dateParam) {
      if(!isNaN(dateParam)){
        try {
          return new Date(dateParam).toISOString().replace(/-/g, '-').replace(/T.+/, '');
        } catch (error) {
          return dateParam;
        }
      } else {
        return dateParam;
      }
    };

    this.find = function (thirdPartyDataId) {
      var tpdParams = {
        id: thirdPartyDataId
      };

      return $http({
        method: 'GET',
        url: '/api/v1/tpd',
        params: tpdParams
      }).then(function (response) {
        return response.data;
      });
    };
  });



//////////////////
// WEBPACK FOOTER
// ./src/main/resources/static/scripts/repositories/TpdRepository.js
// module id = 622
// module chunks = 0